module.exports = __webpack_public_path__ + "img/convert.6148f08a.png";